import { Cloudinary } from "@cloudinary/url-gen";

const prodCloudinary = new Cloudinary({
  cloud: {
    cloudName: import.meta.env.VITE_CLOUDINARY_CLOUD_NAME,
  },
  url: {
    secure: true,
  },
});

const devCloudName = import.meta.env.VITE_DEV_CLOUDINARY_CLOUD_NAME;
const devCloudinary = devCloudName
  ? new Cloudinary({
      cloud: { cloudName: devCloudName },
      url: { secure: true },
    })
  : null;

/**
 * Public ID prefixes that live on the production Cloudinary cloud.
 * Keep in sync with backend `assetUtils.isProdCloudinaryAsset`.
 *
 * Normal prod uploads use the `prod` upload-preset folder (`prod/...`).
 * Some import tooling wrote assets into custom folders on the prod cloud
 * without that prefix (`tripper-imports/`, `ohto-imports/`).
 */
const PROD_CLOUDINARY_PREFIXES = [
  "prod/",
  "tripper-imports/",
  "ohto-imports/",
] as const;

const isProdCloudinaryAsset = (assetId?: string) =>
  !!assetId &&
  PROD_CLOUDINARY_PREFIXES.some(prefix => assetId.startsWith(prefix));

/**
 * Returns the correct Cloudinary instance based on the asset's _id prefix.
 * Mirrors backend `assetUtils.cn`:
 * - prod-cloud prefixes → production Cloudinary account
 * - everything else → app/dev account when configured (local uploads, org/mediaGallery, etc.)
 */
const getCloudinary = (assetId?: string) => {
  if (!devCloudinary) return prodCloudinary;
  return isProdCloudinaryAsset(assetId) ? prodCloudinary : devCloudinary;
};

/** @deprecated Use getCloudinary(assetId) for environment-aware cloud selection */
const cloudinary = prodCloudinary;

export { cloudinary, getCloudinary };
